import script from "./DistributionList.vue?vue&type=script&setup=true&lang=js"
export * from "./DistributionList.vue?vue&type=script&setup=true&lang=js"

import "./DistributionList.vue?vue&type=style&index=0&id=0ed08112&lang=css"

const __exports__ = script;

export default __exports__